import { createReducer, on } from '@ngrx/store';
import { AlarmManagementModel } from '@models/alarm-management.model';
import { AlarmManagementAction } from '@states/alarm-mangment/alarm-management.action-types';

export interface AlarmManagementState {
  activeAlarms: AlarmManagementModel.AlarmData[];
  canceledAlarms: AlarmManagementModel.AlarmData[];
  allAlarms: AlarmManagementModel.AlarmData[];
  selectedAlarm: AlarmManagementModel.AlarmData | null;
  checkResult: AlarmManagementModel.AlarmCheckResponse | null;
  currentFilter: AlarmManagementModel.AlarmFilter;
  isLoading: boolean;
  error: string | null;
}

export const initialState: AlarmManagementState = {
  activeAlarms: [],
  canceledAlarms: [],
  allAlarms: [],
  selectedAlarm: null,
  checkResult: null,
  currentFilter: {},
  isLoading: false,
  error: null,
};

export const alarmManagementReducer = createReducer(
  initialState,

  // Reset State
  on( AlarmManagementAction.resetToInitialState, () => ({
    ...initialState,
  })),

  // Loading State
  on( AlarmManagementAction.setAlarmsLoading, (state, { isLoading }) => ({
    ...state,
    isLoading,
    error: isLoading ? null : state.error,
  })),

  // Active Alarms
  on( AlarmManagementAction.getActiveAlarmsSuccess, (state, { activeAlarms }) => ({
    ...state,
    activeAlarms,
    error: null,
  })),
  on( AlarmManagementAction.getActiveAlarmsFail, (state) => ({
    ...state,
    error: 'Failed to load active alarms',
  })),

  // Canceled Alarms
  on( AlarmManagementAction.getCanceledAlarmsSuccess, (state, { canceledAlarms }) => ({
    ...state,
    canceledAlarms,
    error: null,
  })),
  on( AlarmManagementAction.getCanceledAlarmsFail, (state) => ({
    ...state,
    error: 'Failed to load canceled alarms',
  })),

  // Alarm History
  on( AlarmManagementAction.getAlarmHistorySuccess, (state, { alarms }) => ({
    ...state,
    allAlarms: alarms,
    error: null,
  })),
  on( AlarmManagementAction.getAlarmHistoryFail, (state) => ({
    ...state,
    error: 'Failed to load alarm history',
  })),

  // Create Alarm
  on( AlarmManagementAction.createAlarmSuccess, (state, { alarmId }) => ({
    ...state,
    error: null,
  })),
  on( AlarmManagementAction.createAlarmFail, (state) => ({
    ...state,
    error: 'Failed to create alarm',
  })),

  // Cancel Alarm
  on( AlarmManagementAction.cancelAlarmSuccess, (state) => ({
    ...state,
    error: null,
  })),
  on( AlarmManagementAction.cancelAlarmFail, (state) => ({
    ...state,
    error: 'Failed to cancel alarm',
  })),

  // Check Active Alarm
  on( AlarmManagementAction.checkActiveAlarmSuccess, (state, { checkResult }) => ({
    ...state,
    checkResult,
    error: null,
  })),
  on( AlarmManagementAction.checkActiveAlarmFail, (state) => ({
    ...state,
    error: 'Failed to check active alarm',
  })),

  // UI State
  on( AlarmManagementAction.setSelectedAlarm, (state, { alarm }) => ({
    ...state,
    selectedAlarm: alarm,
  })),
  on( AlarmManagementAction.setAlarmFilter, (state, { filter }) => ({
    ...state,
    currentFilter: filter,
  }))
);
